import { formatHfbTitle } from "@coworker/app/src/components/RoomSettings/Helpers/hfbHelpers";
import { useTranslation } from "@coworker/locales";
import {
  FilterType,
  FilterValue,
  InputType,
  MultiSelectFilter,
  RowVisibility,
} from "../../../shared/filters/types/filter";
import type { ApplyFilter } from "../../../shared/filters/types/apply";
import type { LaunchMedia } from "../../types/launch";
import {
  getMediaHfb,
  matchesSelection,
  OTHER_HFB,
  sortedUnique,
  type LaunchMediaRow,
} from "../../utils/launchMediaFilters";

const HFB_ID = "hfb";

export function useHfbMultiSelectLaunchMediaFilter(
  medias: LaunchMedia[]
): ApplyFilter<MultiSelectFilter, LaunchMediaRow> {
  const { t } = useTranslation();
  const all = sortedUnique(medias.map(getMediaHfb));
  // "Other areas" always last
  const values = [...all.filter((h) => h !== OTHER_HFB)].concat(
    all.includes(OTHER_HFB) ? [OTHER_HFB] : []
  );

  return {
    filter: {
      inputType: InputType.MultiSelect,
      filterType: FilterType.Filter,
      id: HFB_ID,
      title: t("hfbString"),
      options: values.map((value) => ({
        value,
        title: formatHfbTitle(value, t),
      })),
      enabled: true,
      showSearch: true,
      rowVisibility: RowVisibility.PillOnly,
      defaultValue: { filterId: HFB_ID, value: [] },
    },
    filterCompare: ({ media }: LaunchMediaRow, { value }: FilterValue) =>
      matchesSelection(value, values, getMediaHfb(media)),
  };
}
